import { AppStatusState, AppStatusMutations, AppStatusActions, PostPatientResponseError, Error } from '@/types'
import { AppStatusMutationType } from './mutation-types'

const state: AppStatusState = {
  errors: false,
  data: null,
  message: ''
}

const mutations: AppStatusMutations = {
  error (state, payload) {
    state = Object.assign(state, payload)
  }
}

const actions: AppStatusActions = {
  clearError ({ commit }) {
    commit(AppStatusMutationType.error, {
      errors: false,
      data: null,
      message: ''
    })
  },
  updateError ({ commit }, error: Error) {
    if (typeof error.errors === 'boolean') {
      commit(AppStatusMutationType.error, error)
      return
    }
    commit(AppStatusMutationType.error, {
      errors: true,
      data: error.errors,
      message: error.message
    })
  }
}

export const app = {
  state,
  mutations,
  actions
}
